<template>
    <div class="c-a-input c-a-input--autocomplete">
        <label class="c-a-input__label" :for="name">{{ label }}</label>
        <div
            class="c-a-input__wrapper c-a-input__wrapper--with-icon-left c-a-input__wrapper--with-button"
        >
            <icon class="c-a-input__icon" :icon="'pin_drop'"></icon>
            <v-select
                :options="subRegions"
                @search="isSearching"
                label="Name"
                style="width: 100%; height: 3rem"
                :select-on-key-codes="[9, 13]"
                :append-icon="null"
                v-model="model"
            >
                <span slot="no-options"
                    >Kan inte hitta en kommun som matchar din sökning.</span
                >
            </v-select>
            <button
                class="c-a-input__icon-button"
                aria-label="Hitta din plats automatiskt"
                style="cursor: pointer; z-index: 1"
                v-tooltip="{
                    content: 'Hitta din plats automatiskt',
                    placement: 'top-center'
                }"
                @click="getRegionByLocation"
            >
                <icon
                    v-if="closestRegionLoading"
                    class="c-a-icon--animation-spinner"
                    :icon="'spinner'"
                />
                <icon v-else :icon="'location_searching'" />
            </button>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
    FETCH_FILTERS,
    FETCH_CLOSEST_REGION,
    GET_CLOSEST_REGION,
    GET_REGIONS
} from "../../../../store/store-models/filters-model";

import AutocompleteItem from "./AtomInputAutocompleteItemRegion.vue";
import ButtonAtom from "../AtomButton.vue";
import Icon from "../AtomIcon.vue";
import vSelect from "vue-select";
import Vue from "vue";
Vue.component("v-select", vSelect);
export default {
    props: [
        "name",
        "label",
        "placeholder",
        "value",
        "searchFunction",
        "categorieIsSet",
        "regionIsSet"
    ],
    data() {
        return {
            subRegions: [],
            subregionsCache: [],
            matchedSubRegions: [],
            itemTemplate: AutocompleteItem,
            closestRegionLoading: false,
            isCreated: false,
            keyDownQuery: "",
            selected: ""
        };
    },
    components: {
        ButtonAtom,
        Icon,
        vSelect
    },
    computed: {
        ...mapGetters({
            closestRegion: GET_CLOSEST_REGION,
            regions: GET_REGIONS
        }),
        filteredSuggestions() {
            return [
                {
                    data: this.subRegions.filter(item => {
                        return (
                            item.Name.toLowerCase().indexOf(
                                this.query.toLowerCase()
                            ) > -1
                        );
                    })
                }
            ];
        },
        model: {
            get: function() {
                return this.value;
            },
            set: function(val) {
                this.$emit("input", val);
            }
        }
    },

    methods: {
        ...mapActions({
            fetchClosestRegion: FETCH_CLOSEST_REGION,
            fetchFilters: FETCH_FILTERS
        }),
        selectHandler(item) {
            this.updateItem(item);
        },
        isSearching(value) {
            const matchingOption = this.subRegions.find(
                r => r.Name.toLowerCase() === value.toLowerCase()
            );
            if (matchingOption) {
                this.selected = matchingOption;
                this.setSelected(value);
            }
        },
        createSubRegionsArray() {
            const arr = [];
            for (var region in this.regions) {
                for (var subCat in this.regions[region].Subcategories) {
                    arr.push(this.regions[region].Subcategories[subCat]);
                }
            }
            arr.sort((a, b) => a.Name.localeCompare(b.Name));
            this.subRegions = arr;
            this.subregionsCache = this.subRegions;
        },
        getRegionByLocation(e) {
            if (e) {
                e.preventDefault();
            }
            if (this.regionIsSet) return;
            if ("geolocation" in navigator) {
                this.closestRegionLoading = true;
                navigator.geolocation.getCurrentPosition(
                    // Success
                    async position => {
                        // Mappa koordinater mot lista över tillgängliga regioner, hitta närmaste och hämta relevant data från .NET
                        this.closestRegionLoading = false;
                        const coords = {
                            lng: position.coords.longitude,
                            lat: position.coords.latitude
                        };
                        await this.fetchClosestRegion(coords);
                        this.selected = this.closestRegion;
                        this.$emit("input", this.selected);
                    },
                    // Failure
                    () => {
                        this.closestRegionLoading = false;
                    },
                    // Options
                    {
                        timeout: 10000
                    }
                );
            } else if (this.closestRegion) {
                this.model = this.closestRegion;
            }
        }
    },
    async created() {
        this.isCreated = true;
        await this.fetchFilters();
        this.createSubRegionsArray();

        if (!this.value && this.closestRegion && !this.categorieIsSet) {
            this.model = this.closestRegion;
        }
    },
    mounted() {
        this.isCreated = false;
        this.getRegionByLocation();
    }
};
</script>
<style>
.vs__selected-options {
    display: flex;
    flex-basis: 100%;
    flex-grow: 1;
    flex-wrap: wrap;
    position: relative;
    left: 1.7rem;
}

.vs__dropdown-toggle {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: flex;
    padding: 0 0 4px;
    background: none;
    border: 1px solid rgba(60, 60, 60, 0.26);
    white-space: normal;
    height: 3rem !important;
    border-radius: 0 !important;
    border: 1px solid #005b83 !important;
    background-color: white !important;
}

.vs__clear {
    fill: rgba(60, 60, 60, 0.5);
    padding: 0;
    border: 0;
    background-color: transparent;
    cursor: pointer;
    margin-right: 8px;
    display: none;
}

.vs__actions {
    display: none;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 0.5rem;
    position: absolute;
    top: 50%;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    height: 3rem;
    width: 3rem;
    background-color: #005b83;
    color: #fff !important;
    pointer-events: none;
}

.vs__open-indicator {
    fill: white;
    transform: scale(1);
    transition: transform 0.15s cubic-bezier(1, -0.115, 0.975, 0.855);
    transition-timing-function: cubic-bezier(1, -0.115, 0.975, 0.855);
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
    background: #dfe5fb;
    border: none;
    color: #394066;
    text-transform: lowercase;
    font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
    fill: #394066;
}
</style>



// WEBPACK FOOTER //
// src/views/components/atoms/form/AtomInputAutocompleteRegion.vue